import { ElementRef, Injectable } from '@angular/core';
import { ScrollToConfigOptions, ScrollToService } from '@nicky-lenaers/ngx-scroll-to';

@Injectable()
export class DeliveryUiHelperService {

  constructor(private _scrollToService: ScrollToService) {
  }

  public scrollToDatepicker(label: ElementRef<HTMLElement>, datepickerHeight: number = 410,
                            containerRef: string | number | ElementRef | HTMLElement = null) {
    try {
      const elemTop = label.nativeElement.getBoundingClientRect().top,
        elemBottom = elemTop + datepickerHeight,
        pageBottom = window.innerHeight;

      const options: ScrollToConfigOptions = {
        offset: elemBottom - pageBottom + 20,
        ...(containerRef && { container: containerRef })
      };

      if (pageBottom < elemBottom) {
        this._scrollToService.scrollTo(options);
      }
    } catch (e) {
      console.error(e);
    }
  }
}
